import { useContext } from "react";

import { ApplicationContext } from "../ApplicationContextProvider";

export const useApplicationContext = (configuration, depends) => {
  const context = useContext(ApplicationContext);

  return depends.reduce((resolved, item) => resolved?.[item]?.[context[item]], configuration);
};
